import labels from 'labels.json';

export default _ => {
	return Promise.resolve(labels);
};
